import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function PainSolutionSection() {
  const pains = ['Lunes que empezás de cero porque el fin de semana "arruinaste todo"', 'Días contando calorías sin resultados porque nadie te habló de hormonas', 'Ejercicio que no alcanza porque el cortisol está saboteando todo por adentro', 'Recetas "saludables" que no tienen nada que ver con la comida argentina real', 'Ayuno mal aplicado que te genera más ansiedad y no quema nada', 'Báscula que no baja aunque hagas todo bien y no entendés por qué', 'Fin de semana familiar donde perdés el control y sentís que sos la única', 'El mismo ciclo de siempre — el próximo año, otra vez desde cero'];
  const solutions = ['Plan de 21 días completo con comida real argentina — desayuno, almuerzo, merienda y cena', 'Protocolo hormonal específico para mujeres 40+ que reactiva el metabolismo desde adentro', 'Sistema de control de cortisol en 5 pasos — dormís mejor, quemás más grasa abdominal', '50+ recetas rápidas (menos de 30 minutos) con ingredientes de Coto, Carrefour o Jumbo', '5 protocolos de ayuno adaptados a tu etapa hormonal — sin arruinar la tiroides', 'Diario de transformación que mide progreso real más allá de la báscula', 'Guía express para sobrevivir asados, cumpleaños y salidas sin arruinar tu progreso', 'Sistema completo de mantenimiento de por vida — nunca más empezar de cero'];
  return <>
      {/* PAIN SECTION */}
      <section className="bg-zinc-950 text-white py-20 px-4 border-t border-zinc-900" data-id="element-117">
        <div className="max-w-4xl mx-auto" data-id="element-118">
          <div className="text-center mb-12" data-id="element-119">
            <h2 className="font-display font-black text-4xl md:text-5xl mb-6 uppercase text-red-500" data-id="element-120">
              ¿Cuántos lunes más vas a empezar de cero?
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-121">
              Querés bajar de peso. Lo intentás. Pero nadie te dijo que después
              de los 40 las reglas cambian completamente. No es falta de
              voluntad. No es flojera.{' '}
              <strong className="text-white" data-id="element-122">
                Es falta de un sistema adaptado a tu cuerpo.
              </strong>
            </p>
          </div>

          <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 space-y-4" data-id="element-123">
            {pains.map((pain, i) => <div key={i} className="flex items-start gap-4" data-id="element-124">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-125" />
                <span className="text-lg text-gray-300" data-id="element-126">{pain}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="bg-white text-black py-20 px-4" data-id="element-127">
        <div className="max-w-4xl mx-auto" data-id="element-128">
          <div className="text-center mb-12" data-id="element-129">
            <h2 className="font-display font-black text-4xl md:text-5xl mb-6 uppercase text-brand" data-id="element-130">
              ¿Y si este fuera el último lunes que empezás así?
            </h2>
          </div>

          <div className="bg-brand/5 border-2 border-brand/20 rounded-2xl p-6 md:p-10 space-y-4 shadow-xl shadow-brand/5" data-id="element-131">
            {solutions.map((solution, i) => <div key={i} className="flex items-start gap-4" data-id="element-132">
                <CheckCircle2 className="w-6 h-6 text-brand shrink-0 mt-1" data-id="element-133" />
                <span className="text-lg font-medium text-gray-800" data-id="element-134">
                  {solution}
                </span>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}